import {useSelector} from 'react-redux'
import { Doughnut } from 'react-chartjs-2'
import 'chartjs-plugin-labels'

import {complianceNotEmpty} from '../complianceSlice'

import classes from './ComplianceCharts.module.css'

const dataDisplayText = (data_key,isMAXUser) =>({
	workout:'Workouts',
	task:'Tasks',
	nutrition:'Nutrition',
	simplified_nutrition:(isMAXUser?'MAX Nutrition':'Simplified Nutrition'),
}[data_key])

const ComplianceRow = props =>{
	const {displayKeys,data} = props
	const W = window.innerWidth
	const colors = ['#3fd953','#4160e8','#e85241']
	const labels = ['Complete','Open','Not Met']
	const isMAXUser = Boolean(useSelector(state=>state.users.current_user.isMAXUser))
	if(!data) return null
	//check if data is all empty if so don't display anything
	const dataIsEmpty = !displayKeys.map((key)=>{
		const chartData = (
			key !== 'simplified_nutrition' ?
			[
				parseInt(data[key]?.complete||0),
				parseInt(data[key]?.open||0),
				parseInt(data[key]?.notMet||0)
			] : [
				parseInt(data[key]?.completed||0),
				parseInt(data[key]?.assigned||0)-parseInt(data[key]?.completed||0),
			]
		)
		return chartData.reduce((accumulator, currentValue) => accumulator + currentValue)
	}).reduce((accumulator, currentValue) => accumulator + currentValue)
	if(dataIsEmpty) return null
	return (
		<div className={classes.ComplianceRow}>
			<div className="d-flex justify-content-center w-100 flex-wrap">
				{labels.map((label,i)=>{
					const color = colors[i]
					return (
						<div className="d-flex p-2 align-items-center">
							<span className="mr-2" style={{
								background:color,
								width:'16px',
								height:'16px',
								borderRadius:'100%',
								display:'inline-block'
							}}/>
							<span style={{color:'#ccc'}}>
								{label}
							</span>
						</div>
					)
				})}
			</div>
			{displayKeys.map(key=>{
				//don't show nutrition data for MAX
				if(key==='nutrition' && isMAXUser) return null
				const chartData = (
					key !== 'simplified_nutrition' ?
					[
						parseInt(data[key].complete),
						parseInt(data[key].open),
						parseInt(data[key].notMet)
					] : [
						parseInt(data[key].completed),
						parseInt(data[key].assigned)-parseInt(data[key].completed),
					]
				)
				//if no data hide chart
				if(!chartData.reduce((accumulator, currentValue) => accumulator + currentValue)){
					return null
				}
				console.log(chartData)
				const chartLabels = (
					key !== 'simplified_nutrition' && key !== 'max_nutrition'?
					['Complete','Open','Not Met'] :
					['Completed','Not Met']
				)
				const chartColors = (
					key !== 'simplified_nutrition' ?
					['#3fd953','#4160e8','#e85241'] :
					['#3fd953','#e85241']
				)
				return(
					<div 
						style={{
							cursor:props.onChartClick?'pointer':'default'
						}}
						onClick={()=>(props.onChartClick || function(){})(key)}
						className={classes.ComplianceDataContainer}>
						<div className={classes.ComplianceChartContainer}>
							<Doughnut 
								data={{
									labels:chartLabels,
									datasets:[{
										backgroundColor:chartColors,
										data:chartData
									}]
								}}
								options={{
									legend:{
										display:false
									},
									maintainAspectRatio:false,
									responsive:true,
									//no need for tooltips
									tooltips:{
										enabled:false
									},
									//no need for color hover change
									hover:{mode:null},
									plugins:{
										labels: {
								            render: (args) => {
								              const total = args.dataset.data.reduce((acc, val) => acc + val, 0);
								              const percentage = ((args.value / total) * 100).toFixed(0);
								              return `${args.value}\n${percentage}%`; // Show actual value & percentage
								            },
								            fontColor: "#fff",
								            fontSize: 16,
								            fontStyle: "bold",
								            position: "border", // Positions label on the border of the segment
								            textShadow: true,
								          },
									}
								}}/>
						</div>
						<div className="text-center text-white pt-2">{dataDisplayText(key,isMAXUser)}</div>
					</div>
				)
			})}
		</div>
	)
}

export default ComplianceRow